import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import Images from "@Theme/Images";
// import { useLocation } from "react-router-dom";

export default function ShareLinkModal({
  handleClose,
  data,
  setSuccess = () => {},
}) {
  // const { pathname } = useLocation();
  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <span>Berbagi Info Loker</span>
        <Icon
          icon={"cross"}
          size={24}
          color={"#0A0A0A"}
          className={Styles.icon}
          onClick={handleClose}
        />
      </div>

      <span className={Styles.spanGrey}>
        Bagikan info loker ini untuk yang lain
      </span>

      <div className={Styles.shareBox}>
        <span>Berbagi melalui</span>
        <div>
          <div
            onClick={() => {
              window.open(`https://wa.me/?text=${window.location.href}`);
            }}
          >
            <Icon icon={"whatsapp-logo"} size={40} />
          </div>

          <div
            onClick={() => {
              window.open(`https://t.me/share/url?url=${window.location.href}`);
            }}
          >
            <img
              src={Images.TELEGRAM_LOGO}
              alt=""
              style={{
                width: "40px",
                height: "40px",
              }}
            />
          </div>
          <div
            onClick={() => {
              window.open(
                `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`
              );
            }}
          >
            <Icon icon={"facebook-logo"} size={40} />
          </div>
          <div
            onClick={() => {
              window.open(
                `https://twitter.com/intent/tweet?url=${window.location.href}&text=Check+this+out!`
              );
            }}
          >
            <Icon icon={"twitter-x-logosvg"} size={40} />
          </div>
        </div>
      </div>

      <div className={Styles.linkBox}>
        <span>Salin link loker</span>
        <div className={Styles.link}>
          <div>{window.location.href}</div>
          <div
            onClick={() => {
              navigator.clipboard
                .writeText(window.location.href)
                .then(() => {
                  setSuccess("Link berhasil disalin");
                })
                .catch((error) => {
                  // Tangani error jika copy ke clipboard gagal
                  console.error("Gagal menyalin ke clipboard:", error);
                });
            }}
          >
            <Icon icon={"duplicate"} size={16} color={"#1571DE"} />
          </div>
        </div>
      </div>
    </div>
  );
}
